// extracted by mini-css-extract-plugin
export default {"card":"SubCard_card__iYnUl","cardImg":"SubCard_cardImg__DGnN9","center":"SubCard_center__6n+SS"};